export default __webpack_public_path__ + "static/media/RO.cf8a911e.ico";